module.exports = __webpack_public_path__ + "static/media/ceilings_allImpact_60y_y.9c3c78b9.csv";